import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ReasonService {
    constructor(private http: HttpClient) { }

    getDisabilities() {
        return this.http.get('/api/getDisabilities', { responseType: 'json' });
    }

    saveReasonRequest(request: any): Observable<Object> {
        return this.http.post('/api/PersonDisability/save', request);
    }

    saveIntReasonRequest(request: any): Observable<Object> {
        return this.http.post('/api/InternalPersonDisability/save', request);
    }

    removeDisabilityById(PERSON_DISABILITY_ID: string) {
        return this.http.delete(`api/PersonDisability/DeleteDisability`, { params: { "PERSON_DISABILITY_ID": PERSON_DISABILITY_ID }, responseType: 'json', observe: 'response' });
    }

    removeIntPersonDisabilityById(PERSON_DISABILITY_ID: string) {
        return this.http.delete(`api/InternalPersonDisability/DeleteDisability`, { params: { "PERSON_DISABILITY_ID": PERSON_DISABILITY_ID }, responseType: 'json', observe: 'response' });
    }

    delPersonDisabilityIdsByPersonId(personId: string) {
        return this.http.delete(`api/PersonDisability/delPersonDisabilityIdsByPersonId`, { params: { "personId": personId }, responseType: 'json', observe: 'response' });
    }

    getDisabilitiesCategoryName(DISABILITY_CATEGORY_ID) {
        return this.http.get('api/DisabilityCategory/getDisabilitiesCatName', { params: { "type": DISABILITY_CATEGORY_ID }, responseType: 'json', observe: 'response' });
    }

    getDisabilitiesName(DISABILITY_ID) {
        return this.http.get('api/Disability/getDisabilitiesName', { params: { "type": DISABILITY_ID }, responseType: 'json', observe: 'response' });
    }
}



// WEBPACK FOOTER //
// ./client/views/services/reason.service.ts